import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Checkbox, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { MenuItem } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setMenu } from '../../../../commons/functions';

export const SystemUsersGroupEditPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const { data, parameters, menu, idAirport } = useGlobalState();
    const [usersGroups, setUsersGroups] = useState<any[]>([]);
    const [menus, setMenus] = useState<MenuItem[]>([]);
    const [group, setGroup] = useState<any>();
    const [idGroup, setIdGroup] = useState<number>(0);
    const { navigate } = useRouter();
    const isMounted = useRef(false);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                setIdGroup(parseInt(id));
            }
            //handleGetEmail(id ? parseInt(id) : 0);
            //else
            //setMailTemplate(undefined);
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    useEffect(() => {
        handleUserGroup();
    }, [idAirport]);
    useEffect(() => {
        //handleUserGroup();
        console.log("idGroup changed:", idGroup);
        if (idGroup !== 0) {
            handleUserGroup();
        }
    }, [idGroup]);
    const handleUserGroup = async () => { // Make the function async
        try {
            if (idGroup === 0) return;
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/usergroups/get',
                },
                body: JSON.stringify({ idGroup: idGroup }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                if (!dataWeb.userGroup) {
                    addNotification("Grupo no encontrado", 'error', setData);
                    navigate('system/users/groups')
                    return;
                }
                setGroup(dataWeb.userGroup)
                setMenus(dataWeb.menus)
            } else {
                addNotification(dataWeb.status, 'error', setData);
                navigate('#system/users/groups')
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    }
    const handleUpdateUserGroup = async () => { // Make the function async
        try {
            console.log("handleUpdateUserGroup");
            if (!group) return;
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/usergroups/update',
                },
                body: JSON.stringify({ idGroup: group.idGroup, jsonMenu: checkedIds }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                if (dataWeb.menu) {
                    setMenu(dataWeb.menu)
                }
                //setGroup(dataWeb.userGroup)
                //setMenu(dataWeb.menu)
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    }


    const [checkedItems, setCheckedItems] = React.useState<Record<number, boolean>>({});

    // When group.jsonMenu arrives, update checkedItems
    React.useEffect(() => {
        if (group?.jsonMenu) {
            const initial = group.jsonMenu.reduce((acc: Record<number, boolean>, id: number) => {
                acc[id] = true;
                return acc;
            }, {});
            setCheckedItems(initial);
        }
    }, [group?.jsonMenu]);

    const updateParentState = (
        updated: Record<number, boolean>,
        parentId: number | null
    ) => {
        if (!parentId) return;

        const parent = findItemById(menus, parentId);
        if (parent && parent.items) {
            const anyChildChecked = parent.items.some((c) => updated[c.idMenu]);
            updated[parent.idMenu] = anyChildChecked;

            // keep going up the tree
            const grandParent = findParentId(menus, parentId);
            updateParentState(updated, grandParent);
        }
    };
    const toggleChecked = (item: MenuItem, checked: boolean, parentId: number | null = null) => {
        setCheckedItems((prev) => {
            let updated = { ...prev, [item.idMenu]: checked };

            // if parent → toggle descendants
            if (item.items && item.items.length > 0) {
                const childIds = getDescendantIds(item);
                for (const cid of childIds) {
                    updated[cid] = checked;
                }
            }

            // update parent(s)
            if (parentId !== null) {
                updateParentState(updated, parentId);
            }

            return updated;
        });
    };
    // Returns an array of descendant IDs (numbers)
    const getDescendantIds = (item: MenuItem): number[] => {
        let ids: number[] = [];
        if (item.items) {
            for (const child of item.items) {
                ids.push(child.idMenu);
                ids = ids.concat(getDescendantIds(child));
            }
        }
        return ids;
    };

    // Returns parent ID or null
    const findParentId = (
        items: MenuItem[],
        id: number,
        parentId: number | null = null
    ): number | null => {
        for (const item of items) {
            if (item.idMenu === id) return parentId;
            if (item.items) {
                const found = findParentId(item.items, id, item.idMenu);
                if (found !== null) return found;
            }
        }
        return null;
    };

    // Returns MenuItem or null
    const findItemById = (items: MenuItem[], id: number): MenuItem | null => {
        for (const item of items) {
            if (item.idMenu === id) return item;
            if (item.items) {
                const found = findItemById(item.items, id);
                if (found) return found;
            }
        }
        return null;
    };

    const renderMenu = (items: MenuItem[], parentId: number | null = null): JSX.Element => (
        <ul style={{ listStyle: "none", paddingLeft: "1em" }}>
            {items.map((item: MenuItem) => (
                <li key={item.idMenu}>
                    <Checkbox
                        checked={!!checkedItems[item.idMenu]}
                        onChange={({ detail }) => toggleChecked(item, detail.checked, parentId)}
                    >
                        {item.isBreadcrumb === 0 ? (
                            <em>{item.text} [{item.idMenu}]</em>
                        ) : (
                            <>
                                {item.text} [{item.idMenu}]
                            </>
                        )}
                    </Checkbox>

                    {/* pass current item.idMenu as parentId for children */}
                    {item.items && renderMenu(item.items, item.idMenu)}
                </li>
            ))}
        </ul>
    );

    const checkedIds: number[] = useMemo(() => {
        return Object.keys(checkedItems || {})
            .filter((key) => checkedItems[Number(key)])
            .map((key) => Number(key));
    }, [checkedItems]);


    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        if (group?.idGroup && checkedIds?.length >= 0) {
            const timer = setTimeout(() => {
                console.log("Updating user group with checked IDs:", checkedIds);
                handleUpdateUserGroup();
            }, 50);
            return () => clearTimeout(timer);
        }
    }, [checkedIds]);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={group ? <Button variant="link" href='#system/users/groups'>Volver</Button> : null}>{group ? `Grupo ${group.groupName}` : "Grupos de usuario"}</Header>
                    {group && menus && (
                        renderMenu(menus)
                    )}
                </SpaceBetween>
            }
        />
    )
};
